module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "vaterguirgis.d994f3e8.png";